<template>

  <div class="card">
    <div class="row">
      <div class="col-md-10">
        <h5>Información del proveedor</h5>
      </div>
      <div class="col-md-2">
        <button class="btn btn-primary btn-raised" type="button" @click="save">Guardar</button>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-3 text-left">
        <label for="tradename">Nombre comercial</label>
        <input type="text" class="form-control" v-model="supplier.tradename">
      </div>
      <div class="col-md-3 text-left">
        <label for="tel">Webpage</label>
        <input type="text" class="form-control" v-model="supplier.webpage">
      </div>
      <div class="col-md-3 text-left">
        <label for="rfc">Correo comercial</label>
        <input type="text" class="form-control" v-model="supplier.email">
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label>
          Acreditación/Certificado 1
          <a-secure :href="StorageURL + '/storage/private/supplier/'+ usuario + '/' + supplier.acredit_1_file" target="_blank" download>
            <em class="material-icons">file_download</em>
          </a-secure>
          <a-secure :href="StorageURL + '/storage/private/supplier/'+ usuario + '/' + supplier.acredit_1_file" target="_blank">
            <em class="material-icons">open_in_new</em>
          </a-secure>
        </label>
        <formdata-file-upload
          :popup="true"
          field="acredit_1_file"
          title="Certificado 1"
          :path="'/storage/private/supplier/' + usuario + '/'"
          :src="supplier.acredit_1_file"
          :userId="usuario"
          @uploaded="function(a){supplier.acredit_1_file = a}"
          ></formdata-file-upload>
        <!--embed :src="StorageURL + '/storage/private/user/'+ usuario + '/' + supplier.acredit_1_file" type="application/pdf" width="100%" height="300px" v-if="isPDF(supplier.acredit_1_file)"/>
        <div class="file" v-else>
          <img :src="StorageURL + '/storage/private/user/'+ usuario + '/' + supplier.acredit_1_file" alt="No actualizado">
        </div!-->
      </div>
      <div class="col-md-6">
        <label>Acreditación/Certificado 2
          <a-secure :href="StorageURL + '/storage/private/supplier/'+ usuario + '/' + supplier.acredit_2_file" target="_blank" download><em class="material-icons">file_download</em></a-secure>
          <a-secure :href="StorageURL + '/storage/private/supplier/'+ usuario + '/' + supplier.acredit_2_file" target="_blank"><em class="material-icons">open_in_new</em></a-secure></label>
        <formdata-file-upload
          :popup="true"
          field="acredit_2_file"
          title="Certificado 2"
          :path="'/storage/private/supplier/' + usuario + '/'"
          :src="supplier.acredit_2_file"
          :userId="usuario"
          @uploaded="function(a){supplier.acredit_1_file = a}"
          ></formdata-file-upload>
        <!--embed :src="StorageURL + '/storage/private/user/'+ usuario + '/' + supplier.acredit_2_file" type="application/pdf" width="100%" height="300px" v-if="isPDF(supplier.acredit_2_file)"/>
        <div class="file" v-else>
          <img :src="StorageURL + '/storage/private/user/'+ usuario + '/' + supplier.acredit_2_file" alt="No actualizado">
        </div!-->
      </div>
      <div class="col-md-6">
        <label>Acreditación/Certificado 3
          <a-secure :href="StorageURL + '/storage/private/supplier/'+ usuario + '/' + supplier.acredit_3_file" target="_blank" download><em class="material-icons">file_download</em></a-secure>
          <a-secure :href="StorageURL + '/storage/private/supplier/'+ usuario + '/' + supplier.acredit_3_file" target="_blank"><em class="material-icons">open_in_new</em></a-secure></label>
        <formdata-file-upload
          :popup="true"
          field="acredit_3_file"
          title="Certificado 3"
          :path="'/storage/private/supplier/' + usuario + '/'"
          :src="supplier.acredit_3_file"
          :userId="usuario"
          @uploaded="function(a){supplier.acredit_3_file = a}"
          ></formdata-file-upload>
        <!--embed :src="StorageURL + '/storage/private/user/'+ usuario + '/' + supplier.acredit_3_file" type="application/pdf" width="100%" height="300px" v-if="isPDF(supplier.acredit_3_file)"/>
        <div class="file" v-else>
          <img :src="StorageURL + '/storage/private/user/'+ usuario + '/' + supplier.acredit_3_file" alt="No actualizado">
        </div!-->
      </div>
      <div class="col-md-6">
        <label>Presentación ejecutiva
          <a-secure :href="StorageURL + '/storage/private/supplier/'+ usuario + '/' + supplier.cv_file" target="_blank" download><em class="material-icons">file_download</em></a-secure>
          <a-secure :href="StorageURL + '/storage/private/supplier/'+ usuario + '/' + supplier.cv_file" target="_blank"><em class="material-icons">open_in_new</em></a-secure></label>
        <formdata-file-upload
          :popup="true"
          field="cv_file"
          title="CV"
          :path="'/storage/private/supplier/' + usuario + '/'"
          :src="supplier.cv_file"
          :userId="usuario"
          @uploaded="function(a){supplier.cv_file = a}"
          ></formdata-file-upload>
        <!--embed :src="StorageURL + '/storage/private/user/'+ usuario + '/' + supplier.cv_file" type="application/pdf" width="100%" height="300px" v-if="isPDF(supplier.cv_file)"/>
        <div class="file" v-else>
          <img :src="StorageURL + '/storage/private/user/'+ usuario + '/' + supplier.cv_file" alt="No actualizado">
        </div!-->
      </div>
      <div class="col-md-6">
        <label>Logo</label>
        <formdata-file-upload
          :popup="true"
          field="logo_file"
          title="Logotipo"
          :is_public="true"
          :path="'https://cdn.redgirasol.com/logos'"
          :src="supplier.logo_file"
          :rl="true"
          :userId="usuario"
          @uploaded="function(a){supplier.logo_file = a}"
          ></formdata-file-upload>
        <!--div class="file">
          <img :src="StorageURL + '/storage/private/supplier/'+ usuario + '/' + supplier.logo_file" alt="No actualizado">
        </div!-->
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-left">
        <label for="tradename">URL acreditaciones</label>
        <input type="text" class="form-control" v-model="supplier.acredit_url">
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 text-left">
        <label for="tradename">Paneles</label>
        <table class="table" v-if="supplier.panels != null">
          <tbody>
            <tr v-for="p in supplier.panels.split(':;')">
              <td>{{p}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-4 text-left">
        <label for="tel">Inversores</label>
        <table class="table" v-if="supplier.inverters != null">
          <tbody>
            <tr v-for="i in supplier.inverters.split(':;')">
              <td>{{i}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-4 text-left">
        <label for="tradename">Racks</label>
        <table class="table" v-if="supplier.racks != null">
          <tbody>
            <tr v-for="r in supplier.racks.split(':;')">
              <td>{{r}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 text-left">
        <label for="tradename">Extra info</label>
        <textarea type="text" class="form-control" v-model="supplier.extra_info"></textarea>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-left">
        <label for="tradename">Nombre Testimonio 1</label>
        <input type="text" class="form-control" v-model="supplier.testimony_name_1">
      </div>
      <div class="col-md-3 text-left">
        <label for="tel">Teléfono Testimonio 1</label>
        <input type="text" class="form-control" v-model="supplier.contact_phone_1">
      </div>
      <div class="col-md-3 text-left">
        <label for="tradename">Nombre Testimonio 2</label>
        <input type="text" class="form-control" v-model="supplier.testimony_name_2">
      </div>
      <div class="col-md-3 text-left">
        <label for="tel">Teléfono Testimonio 2</label>
        <input type="text" class="form-control" v-model="supplier.contact_phone_2">
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-left">
        <label for="tradename">Nombre Testimonio 3</label>
        <input type="text" class="form-control" v-model="supplier.testimony_name_3">
      </div>
      <div class="col-md-3 text-left">
        <label for="tel">Teléfono Testimonio 3</label>
        <input type="text" class="form-control" v-model="supplier.contact_phone_3">
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-left">
        <label for="tradename">Facebook</label>
        <input type="text" class="form-control" v-model="supplier.facebook">
      </div>
      <div class="col-md-3 text-left">
        <label for="tel">Youtube</label>
        <input type="text" class="form-control" v-model="supplier.youtube">
      </div>
      <div class="col-md-3 text-left">
        <label for="tradename">Twitter</label>
        <input type="text" class="form-control" v-model="supplier.twitter">
      </div>
      <div class="col-md-3 text-left">
        <label for="tel">Instagram</label>
        <input type="text" class="form-control" v-model="supplier.instagram">
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-left">
        <label for="tradename">LinkedIn</label>
        <input type="text" class="form-control" v-model="supplier.linkedin">
      </div>
    </div>
    <br>
  </div>

</template>

<script lang="js">
import ASecure from "@components/utils/aSecure";
let FormDataFileUpload = require('../formdata-file-upload').default;
import Vue from 'vue'
import Toasted from 'vue-toasted';
Vue.use(Toasted)

  export default  {
    name: 'supplier-info',
    props: ['id_supplier', 'usuario'],
    components: {
      ASecure,
        'formdata-file-upload': FormDataFileUpload,
    },
    mounted() {
      axios.get( '/api/info/supplier/' + this.id_supplier).then(response => {
        this.supplier = response.data
      })
    },
    data() {
      return {
        supplier:{}
      }
    },
    methods: {
      save(){
        Vue.toasted.show('Guardando...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post('/api/info/supplier/' + this.id_supplier, this.supplier).then(response => {
          Vue.toasted.clear()
          Vue.toasted.show('Información guardada!!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 2000 })
        }).catch(error => {
          Vue.toasted.clear()
          Vue.toasted.show('Parece que ha ocurrido un error, inténtalo de nuevo', { position: 'bottom-center', type:'error', closeOnSwipe: true})
        })
      },
      isPDF(filename){
        if(filename != null){
          var datas = filename.split('.')
          var data = datas[datas.length-1]
          if(data.toUpperCase() == 'PDF'){
            return true
          }else{
            return false
          }
        }
      }
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .supplier-info {

  }
  .header-row{
    margin-top: 10px;
  }
  .col-md-6{
    margin-top: 10px;
  }
  .row{
    margin-top: 15px;
  }
  .card{
    padding: 0 10px;
  }

  .file{
    min-height: 300px;
    max-height: 300px;
    overflow: hidden;
  }
  .file:hover{
    overflow: auto;
  }
  .file img{
    width: 100%
  }
</style>
